export default "__VITE_ASSET__BDn6FkGZ__"